import { DxPopupModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlPopUpComponent } from './control-pop-up.component';



@NgModule({
  declarations: [
    ControlPopUpComponent
  ],
	exports: [
		ControlPopUpComponent
	],
  imports: [
    CommonModule,

		DxPopupModule,
  ]
})
export class ControlPopUpModule { }
